import ProductsDatatable from "../../components/admin/ProductsDatatable";

const AdminProducts = () => {
  return <ProductsDatatable />;
};

export default AdminProducts;
